import * as React from 'react';

const ArchiveIcon = ({ color = '#BEBECE', ...props }) => (
	<svg width={17} height={12} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M.073 5.812c.019-.063 0-.13.037-.19L3.1 1.088A2.408 2.408 0 0 1 5.11 0h6.78c.808 0 1.562.408 2.01 1.087l2.99 4.536c.038.058.019.126.037.19L17 5.99v3.571C17 10.909 15.92 12 14.586 12H2.414C1.08 12 0 10.909 0 9.562v-3.57l.073-.18Zm12.731-3.988a1.094 1.094 0 0 0-.914-.494H5.11c-.368 0-.71.185-.914.494L1.887 5.326H4.64c.914 0 1.795.513 2.184 1.403.283.653.927 1.11 1.677 1.11s1.394-.457 1.677-1.11c.39-.89 1.27-1.402 2.184-1.403h2.751l-2.308-3.502ZM1.316 9.562a1.105 1.105 0 0 0 1.097 1.109h12.173a1.105 1.105 0 0 0 1.097-1.109V6.656H12.36c-.434 0-.827.248-.977.606A3.145 3.145 0 0 1 8.5 9.168c-1.29 0-2.4-.784-2.884-1.906-.15-.358-.543-.606-.977-.606H1.317v2.906Z'
			fill={color}
		/>
	</svg>
);

export default ArchiveIcon;
